<template lang="pug">
form.searchField(@submit.stop.prevent="submitSearch($event)")
	.searchField__wrapper
		label.searchField__label.sr-only(for="search") Search
		input.searchField__input#search(v-model="query", :placeholder="settings.searchPlaceholder", type="text")
		button.searchField__submit.ico-search(type="submit")
			span.sr-only {{ settings.searchButtonText }}
	.searchField__results
		p Displaying results {{ currentResultStart }} - {{ currentResultsEnd }} of {{ this.results.totalResultCount }}
		search-pagination(@submitPage='setPage', :small="true")
//- .search-header
//-   h1.search-header__heading {{ settings.headerText }}
//-   .search-header__form
//-     input.search-header__input(
//-       @keyup.enter="submitSearch",
//-       v-model="query",
//-       :placeholder="settings.searchPlaceholder",
//-       type="text")
//-     button.search-header__submit.btn(type="submit", @click="submitSearch") {{ settings.searchButtonText }}

//-   .search-header__results Displaying results {{ currentResultStart }} - {{ currentResultsEnd }} of {{ this.results.totalResultCount }}
</template>

<script>
import SearchPagination from "./SearchPagination";
export default {
  components: {
    SearchPagination,
  },
  props: {
    searchPlaceholder: {
      type: String,
    },
    searchButtonText: {
      type: String,
    },
  },
  methods: {
    // checkForEnterKey: function (e) {
    //   if (e.keyCode === 13) {
    //     this.submitSearch();
    //   }
    // },
    setPage: function (index) {
      this.$emit("setPage", index);
    },
    submitSearch: function (e) {
			const input = this.$el.querySelector("input#search");
			if (input.value.length >= 3) {
	      this.$emit("submitSearch", this.query);
			}
    },
  },
  watch: {
    currentQuery() {
      this.query = this.$store.state.searchQuery.searchTerm;
    },
  },
  mounted: function () {
    this.query = this.currentQuery.searchTerm;
  },
  data: function () {
    return {
      query: "",
    };
  },
  computed: {
    settings: function () {
      return this.$store.state.settings;
    },

    currentResultStart: function () {
      if (this.results.currentPage == 0) {
        return 1;
      } else {
        return this.results.currentPage * this.results.pageSize + 1;
      }
    },
    currentResultsEnd: function () {
      if (this.results.currentPage == 0) {
        if (this.results.totalResultCount <= this.results.pageSize) {
          return this.results.totalResultCount;
        } else {
          return this.results.pageSize;
        }
      } else {
        var max = (this.results.currentPage + 1) * this.results.pageSize + 1;
        if (max > this.results.totalResultCount) {
          return this.results.totalResultCount;
        } else {
          return max;
        }
      }
    },
    results: function () {
      return this.$store.state.results;
    },
    currentQuery: function () {
      return this.$store.state.searchQuery;
    },
  },
};
</script>

<style lang="scss" scoped>
.search-header {
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
  &__heading {
    @include fluid(font-size, 1.25rem, 2rem);
    display: inline-block;
    margin: 0 0 1rem;
    &:only-child {
      margin: 0;
    }
  }
  &__form {
    flex: 1 1 100%;
    display: flex;
    background: $backgroundInput;
    padding: 0;
    margin: 0 0 1.5rem;
  }
  &__input[class] {
    flex: 1 1 100%;
    width: 100%;
    margin: 0;
    padding: 1rem;
    background: transparent;
  }
  &__submit {
    flex: 0 0 auto;
		cursor: pointer;
  }
  &__results {
    font-size: 0.875rem;
    line-height: 1;
    margin-bottom: 0.5rem;
  }
}
.searchField {
	&:is(form),
	&:is(form:not(html.kentico-page-builder *)) {
		width: 100%;
	}
	&__submit {
		cursor: pointer;
	}
}
</style>
